import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    // baseUrl: "http://10.10.30.234:8000/v1",
    // baseUrl: "http://10.10.30.197:8000/v1",
    // prepareHeaders: async (headers, { getState, endpoint }) => {
    //   const token = getState().auth.accessToken;
    //   if (token) {
    //     headers.set("Authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
  }),
  tagTypes: [],
  endpoints: (build) => ({}),
});
